export default "__VITE_ASSET__D4$Nr4WD__"